module.exports = __webpack_public_path__ + "img/test-notif-avatar.2c8871e2.svg";